import { formatDate } from '@helpers/helper.novelty'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Novelty, RealEstateDataPageComponentData, TagMediacore } from 'types'

type Props = {
  skeleton: boolean
  novelty: Novelty
  tags: TagMediacore[]
  dateFormat?: 'long' | 'short'
}

const Novelty_Card_8 = (props: Props & RealEstateDataPageComponentData) => {
  const {
    novelty,
    skeleton,
    global_data: {
      divisionPath,
      content: {
        cardsNovelties: {
          data: { titleColor, backgroundColor, paragraphColor },
        },
      },
    },
    backgroundSecondary,
  } = props

  const noveltyPath = novelty?.id
    ? `${divisionPath ?? ''}/novedad/${novelty.id}/${novelty.slug}`
    : '/'

  return (
    <section
      id="novelty-card"
      className="novelty-card-8"
      style={
        backgroundSecondary
          ? { backgroundColor: 'var(--tertiaryColor' }
          : backgroundColor
          ? { backgroundColor: backgroundColor }
          : {}
      }
    >
      <Row className="align-items-center py-4 border-top-bottom">
        <Col
          xs={12}
          lg={4}
          className={`d-flex ${skeleton ? 'skeleton' : ''}`}
        >
          <Link
            to={noveltyPath}
            className="cursor-pointer w-100"
          >
            <div className={`image-zoom-container`}>
              <img
                src={novelty?.image}
                alt="portada"
                className="image-zoom"
                style={{
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
            </div>{' '}
          </Link>
        </Col>
        <Col
          xs={12}
          lg={8}
          className="text-start ps-lg-5"
        >
          <div
            className={`d-flex justify-content-between ${
              skeleton ? 'skeleton' : ''
            } align-items-center`}
            style={
              backgroundSecondary
                ? { color: '#FFF' }
                : paragraphColor
                ? { color: paragraphColor }
                : {}
            }
          >
            <h5>NOVEDADES</h5>
            <ElementHTML
              children={formatDate(novelty?.date_published, 'long')}
              elementType={'h5'}
              className="text-dark-gray mb-4 mt-3 mt-lg-0"
            />
          </div>
          <Link
            to={noveltyPath}
            className="cursor-pointer"
          >
            <ElementHTML
              children={novelty?.title}
              elementType={'h3'}
              className="mb-4"
              style={
                backgroundSecondary
                  ? { color: 'var(--primaryColor)' }
                  : titleColor
                  ? { color: titleColor }
                  : {}
              }
            />
          </Link>
          <ElementHTML
            children={novelty?.headline}
            elementType={'p'}
            className={`py-lg-5 ${skeleton ? 'skeleton' : ''}`}
            style={backgroundSecondary ? { color: '#FFF' } : {}}
          />
          <div className={`${skeleton ? 'skeleton mt-5 w-25' : ''}`}>
            <Link
              className={'btn btn-primary border w-auto mt-4'}
              to={noveltyPath}
            >
              {'VER NOVEDAD'}
              <i className={`icon-arrow-stick ms-4`}></i>
            </Link>
          </div>
        </Col>
      </Row>
    </section>
  )
}
export default Novelty_Card_8
